// extracted by mini-css-extract-plugin
module.exports = {"form-group":"adminPurchasedOrders_form-group__foUsY","container":"adminPurchasedOrders_container__1uSgs"};